import React from 'react';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-container">
          <div>
            <div className="footer-logo">
              <Logo />
            </div>
            <p className="footer-about">
              Aledger is a revolutionary WiFi ecosystem that transforms physical devices into digital mining nodes, powered by AI and blockchain technology.
            </p>
            <div className="social-links">
              <a href="#" className="social-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 6C21 6.5 20 6.9 19 7C20 6.3 21 5.2 21.5 4C20.5 4.6 19.4 5 18.2 5.2C17.2 4 15.7 3.2 14 3.2C10.8 3.2 8.2 5.8 8.2 9C8.2 9.5 8.3 10 8.4 10.4C3.7 10.2 1.1 8 0.5 5C0.2 5.9 0 6.9 0 8C0 10 1 11.7 2.5 12.7C1.9 12.7 1.2 12.5 0.7 12.2C0.7 14.8 2.6 17 5.1 17.5C4.3 17.7 3.5 17.7 2.7 17.5C3.3 19.6 5.2 21.1 7.7 21.1C6 22.4 3.9 23 1.7 23C1.4 23 1.2 23 0.9 23C3.4 24.3 6.4 25 9.5 25C19 25 23.5 17.7 23.5 10C23.5 9.8 23.5 9.6 23.5 9.4C24.5 8.6 25.3 7.6 26 6.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
              <a href="#" className="social-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 22H5C3.89543 22 3 21.1046 3 20V4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4V20C21 21.1046 20.1046 22 19 22H15V14H17L18 12H15V10C15 9.44772 15.4477 9 16 9H18V7H16C14.3431 7 13 8.34315 13 10V12H11L10 14H13V22Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
              <a href="#" className="social-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="2" width="20" height="20" rx="5" stroke="white" strokeWidth="2"/>
                  <circle cx="12" cy="12" r="5" stroke="white" strokeWidth="2"/>
                  <circle cx="17.5" cy="6.5" r="1.5" fill="white"/>
                </svg>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="footer-title">About</h3>
            <ul className="footer-links">
              <li className="footer-link"><a href="#">X</a></li>
              <li className="footer-link"><a href="#">Contact</a></li>
              <li className="footer-link"><a href="#">Careers</a></li>
              <li className="footer-link"><a href="#">Press Kit</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="footer-title">Resources</h3>
            <ul className="footer-links">
              <li className="footer-link"><a href="#">FAQ</a></li>
              <li className="footer-link"><a href="#">Support</a></li>
              <li className="footer-link"><a href="#">Whitepaper</a></li>
              <li className="footer-link"><a href="#">Documentation</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="footer-title">Legal</h3>
            <ul className="footer-links">
              <li className="footer-link"><a href="#">Terms of Service</a></li>
              <li className="footer-link"><a href="#">Privacy Policy</a></li>
              <li className="footer-link"><a href="#">Cookies</a></li>
            </ul>
          </div>
        </div>
        
        <div className="copyright">
          &copy; {new Date().getFullYear()} Aledger. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
